import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';

export const changeRoundStatusAction = createAction(ACTIONS.CHANGE_ROUND_STATUS)<{
  roundStatus: string | null;
}>();
